export const REGIONS_LOAD_REQUEST = 'REGIONS_LOAD_REQUEST';
export const REGIONS_LOAD_SUCCESS = 'REGIONS_LOAD_SUCCESS';
export const REGIONS_LOAD_FAILURE = 'REGIONS_LOAD_FAILURE';
